module.exports = __webpack_public_path__ + "img/face-pleading.5796e85d.svg";